import { httpClient } from '@/configs/axios.config'
import type { RedirectTargetResponse, UserProfile, Session } from '@/types/api'

/**
 * Get current user profile from backend
 * Call this after Clerk authentication to get full user context
 */
export async function getCurrentUser(): Promise<UserProfile> {
  const response = await httpClient.get<UserProfile>('/auth/me')
  return response.data
}

export async function getRedirectTarget(): Promise<RedirectTargetResponse> {
  const response = await httpClient.get<RedirectTargetResponse>(
    '/auth/redirect-target'
  )
  return response.data
}

/**
 * Get active sessions for current user
 */
export async function getSessions(): Promise<Session[]> {
  const response = await httpClient.get<Session[]>('/auth/sessions')
  return response.data
}

/**
 * Revoke a specific session
 */
export async function revokeSession(sessionId: string): Promise<void> {
  await httpClient.delete(`/auth/sessions/${sessionId}`)
}
